import { Text } from "@/components/text/text.component";

export function QuizQuestionHelperText({ text }: QuizQuestionHelperTextProps) {
  if (!text) return null;

  return (
    <Text
      variant="body6"
      data-testid="quiz-question-helper-text"
      className="text-greyscale-body text-center font-thin">
      {text}
    </Text>
  );
}

type QuizQuestionHelperTextProps = {
  text?: string | null;
};
